module.exports = __webpack_public_path__ + "img/header-ru.9c2a8f3b.jpg";